/** Homepage on-page SEO strings (WP5 / GO-2809-03). Keep in sync with SSR + index.html shell. */
export const HOME_PAGE_SEO = {
  title: 'AI Travel Itinerary Planner | CitySage',
  description:
    'Plan shareable travel itineraries with AI. CitySage helps travelers and creators build visual trip plans—discover, refine, and share. Start free.',
  h1: 'AI travel itinerary planner',
  lead:
    'Create visual, shareable trip itineraries with AI—built for travelers and creators who plan and post.',
  canonicalPath: '/',
} as const;

export const HOME_PAGE_SSR_HERO_ID = 'citysage-home-ssr-hero';
export const HOME_PAGE_SSR_HERO_MARKER = 'data-citysage-home-ssr-hero';

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Visible homepage H1 + lead for crawlers (initial HTML before hydrate). */
export function buildHomepageSsrHeroHtml(): string {
  return `<header id="${HOME_PAGE_SSR_HERO_ID}" ${HOME_PAGE_SSR_HERO_MARKER} class="citysage-home-ssr-hero">
  <h1>${escapeHtml(HOME_PAGE_SEO.h1)}</h1>
  <p>${escapeHtml(HOME_PAGE_SEO.lead)}</p>
</header>`;
}
